// extracted by mini-css-extract-plugin
module.exports = {"safeHtml":"safe-html_safeHtml__Ca4s6"};